// components/Services.jsx
import React from 'react';
import '../styles/Services.css';

const Services = () => {
  const services = [
    {
      id: 1,
      icon: '🔧',
      title: 'Emergency Plumbing',
      description: '24/7 emergency services for burst pipes, severe leaks, and urgent plumbing issues.',
      tag: '24/7 Available'
    },
    {
      id: 2,
      icon: '🚿',
      title: 'Bathroom & Kitchen',
      description: 'Installation and repair of faucets, sinks, showers, bathtubs, and kitchen fixtures.',
      tag: 'Expert Installation'
    },
    {
      id: 3,
      icon: '🪠',
      title: 'Drain Cleaning',
      description: 'Professional drain unclogging and cleaning services for sinks, toilets, and main lines.',
      tag: 'Same-Day Service'
    },
    {
      id: 4,
      icon: '💧',
      title: 'Water Heater Repair',
      description: 'Repair and installation of water heaters. No hot water? We\'ll fix it fast.',
      tag: 'Fast Response'
    },
    {
      id: 5,
      icon: '🔩',
      title: 'Pipe Repair & Install',
      description: 'Complete pipe repair, replacement, and installation services for your entire home.',
      tag: 'Licensed Pros'
    },
    {
      id: 6,
      icon: '🚽',
      title: 'Toilet Repair',
      description: 'Quick and reliable toilet repair, installation, and replacement services.',
      tag: 'Expert Service'
    },
    {
      id: 7,
      icon: '⚡',
      title: 'Water Pressure Issues',
      description: 'Diagnose and fix low or high water pressure problems throughout your home.',
      tag: 'Advanced Tools'
    },
    {
      id: 8,
      icon: '🏠',
      title: 'Sewer Line Services',
      description: 'Professional sewer line inspection, cleaning, repair, and replacement services.',
      tag: 'Camera Inspection'
    },
    {
      id: 9,
      icon: '❄️',
      title: 'Frozen Pipe Repair',
      description: 'Emergency thawing and repair of frozen pipes to prevent burst pipes and damage.',
      tag: 'Emergency Service'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="services-bg">
        <div className="services-bg-circle services-bg-circle-1"></div>
        <div className="services-bg-circle services-bg-circle-2"></div>
        <div className="services-bg-circle services-bg-circle-3"></div>
      </div>

      <div className="services-container">
        {/* Section Header */}
        <div className="services-header">
          <span className="services-subtitle">What We Offer</span>
          <h2 className="services-title">
            Professional <span className="services-title-highlight">Plumbing Services</span>
          </h2>
          <p className="services-description">
            From minor repairs to major installations, our licensed plumbers handle it all
            with expertise and care.
          </p>
        </div>

        {/* Services Grid */}
        <div className="services-grid">
          {services.map((service, index) => (
            <div 
              key={service.id} 
              className="services-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="services-card-shine"></div>
              <div className="services-card-icon">{service.icon}</div>
              <h3 className="services-card-title">{service.title}</h3>
              <p className="services-card-description">{service.description}</p>
              <span className="services-card-tag">{service.tag}</span>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="services-cta">
          <div className="services-cta-content">
            <span className="services-cta-badge">✅ 100% Satisfaction Guaranteed</span>
            <h3 className="services-cta-title">Need a Plumber Right Now?</h3>
            <p className="services-cta-description">
              Don't wait — get professional help today. Same-day service available!
            </p>
            <div className="services-cta-buttons">
              <button className="services-cta-btn-primary" onClick={() => {
                window.location.href = 'tel:+18334936242';
              }}>
                <span className="services-cta-btn-shine"></span>
                📋 Book Service Now
              </button>
              <a href="tel:+18334936242" className="services-cta-btn-secondary">
                📞 Call Now: +1 (833) 493-6242
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;